module.exports = __webpack_public_path__ + "public/images/program/program-17.33e18513887803f63d117ab26f6acdc6.jpg";